export default __webpack_public_path__ + "static/media/005.6787139b.jpg";